import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroSection from "@/pages/home/components/HeroSection";
import QuickStats from "@/pages/home/components/QuickStats";
import AddressSection from "@/pages/home/components/AddressSection";
import StepsSection from "@/pages/home/components/StepsSection";
import GuideSection from "@/pages/home/components/GuideSection";
import TroubleshootSection from "@/pages/home/components/TroubleshootSection";
import DeviceSection from "@/pages/home/components/DeviceSection";
import SafetySection from "@/pages/home/components/SafetySection";
import FaqSection from "@/pages/home/components/FaqSection";
import AboutSection from "@/pages/home/components/AboutSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-body">
      <SiteHeader />
      <main>
        <HeroSection />
        <QuickStats />
        <AddressSection />
        <StepsSection />
        <GuideSection />
        <TroubleshootSection />
        <DeviceSection />
        <SafetySection />
        <FaqSection />
        <AboutSection />
      </main>
      <SiteFooter />
    </div>
  );
}